import { api } from "./http-client";
import type { AgentRuntimeName } from "@pracownik/shared/types";

export interface RuntimesConfig {
  openclaw: boolean;
  hermes: boolean;
  default: AgentRuntimeName;
}

export interface BetaConfig {
  inviteRequired: boolean;
}

export const configApi = {
  getRuntimes: () => api.get<RuntimesConfig>("/api/config/runtimes"),
  getBeta: () => api.get<BetaConfig>("/api/config/beta"),
};
